import { render, staticRenderFns } from "./ModalDeleteSignature.vue?vue&type=template&id=b919c4a2&"
import script from "./ModalDeleteSignature.vue?vue&type=script&lang=js&"
export * from "./ModalDeleteSignature.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports